const styles = theme => ({
  root: {
    width: 105,
    height:'auto',
    fontSize: 12,
    color: 'white',
    background:'rgba(255, 255, 255, 0.3)',
    display: 'inline',
    position: 'absolute',
    marginLeft: 'calc(100% - 182px)',
    marginTop: 0,
    [theme.breakpoints.up('sm')]: {
      marginLeft: 'calc(100% - 202px)',
      marginTop: 0,
      width: 110,
    },
    [theme.breakpoints.up('md')]: {
      marginLeft: 'calc(100% - 202px)',
      marginTop: 0,
      width: 110,
    },
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Information/components/ApplicationBar/components/ToolBar/components/MarkSpot/styles.js